import { render, staticRenderFns } from "./scanActivityChart.vue?vue&type=template&id=f508e2be&scoped=true&"
import script from "./scanActivityChart.vue?vue&type=script&lang=js&"
export * from "./scanActivityChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f508e2be",
  null
  
)

export default component.exports